function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Input, Form, Button, Select, Alert, Radio, List, Upload, InputNumber, QRCode, Modal, Typography, Switch, Descriptions, message, DatePicker, Divider, Space, Drawer } from 'antd';
import { Container, Row, Col } from "react-bootstrap";
import axios from 'axios';
import Common from "../includes/Common";
import { ExclamationCircleFill, Upload as UploadIc, XCircleFill, CheckCircleFill, Plus } from 'react-bootstrap-icons';
import Receipt from "../Receipt";
import Moment from 'react-moment';
import AddPrescriber from "./AddPrescriber";
import AddBusinessProvider from "./AddBusinessProvider";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var confirm = Modal.confirm;
var Option = Select.Option;
var NewCustomer = function NewCustomer(_ref) {
  var _ref$handleUpdate = _ref.handleUpdate,
    handleUpdate = _ref$handleUpdate === void 0 ? null : _ref$handleUpdate;
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showReceipt = _useState2[0],
    setShowReceipt = _useState2[1];
  var ref = useRef();
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFormLoading = _useState4[0],
    setIsFormLoading = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    successMessage = _useState8[0],
    setSuccessMessage = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    createdValues = _useState0[0],
    setCreatedValues = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    companyOptions = _useState10[0],
    setCompanyOptions = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    companies = _useState12[0],
    setCompanies = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    deptOptions = _useState14[0],
    setDeptOptions = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    serviceOptions = _useState16[0],
    setServiceOptions = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    deptDisabled = _useState18[0],
    setDeptDisabled = _useState18[1];
  var _useState19 = useState(true),
    _useState20 = _slicedToArray(_useState19, 2),
    companyDisabled = _useState20[0],
    setCompanyDisabled = _useState20[1];
  var _useState21 = useState(true),
    _useState22 = _slicedToArray(_useState21, 2),
    serviceDisabled = _useState22[0],
    setServiceDisabled = _useState22[1];
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    serviceTree = _useState24[0],
    setServiceTree = _useState24[1];
  var _useState25 = useState(true),
    _useState26 = _slicedToArray(_useState25, 2),
    insDisabled = _useState26[0],
    setInsDisabled = _useState26[1];
  var _useState27 = useState(0),
    _useState28 = _slicedToArray(_useState27, 2),
    isPdaActive = _useState28[0],
    setIsPdaActive = _useState28[1];
  var _useState29 = useState(0),
    _useState30 = _slicedToArray(_useState29, 2),
    receipAmount = _useState30[0],
    setReceipAmount = _useState30[1];
  var _useState31 = useState(null),
    _useState32 = _slicedToArray(_useState31, 2),
    userCompany = _useState32[0],
    setUserCompany = _useState32[1];
  var _useState33 = useState([]),
    _useState34 = _slicedToArray(_useState33, 2),
    file = _useState34[0],
    setFile = _useState34[1];
  var _useState35 = useState(true),
    _useState36 = _slicedToArray(_useState35, 2),
    uploadDisabled = _useState36[0],
    setUploadDisabled = _useState36[1];
  var _useState37 = useState([]),
    _useState38 = _slicedToArray(_useState37, 2),
    rdata = _useState38[0],
    setRdata = _useState38[1];
  var _useState39 = useState(null),
    _useState40 = _slicedToArray(_useState39, 2),
    currentCompany = _useState40[0],
    setCurrentCompany = _useState40[1];
  var _useState41 = useState([]),
    _useState42 = _slicedToArray(_useState41, 2),
    discounts = _useState42[0],
    setDiscounts = _useState42[1];
  var _useState43 = useState(0),
    _useState44 = _slicedToArray(_useState43, 2),
    discount = _useState44[0],
    setDiscount = _useState44[1];
  var _useState45 = useState([{
      value: 0,
      label: "Direct"
    }]),
    _useState46 = _slicedToArray(_useState45, 2),
    bpOptions = _useState46[0],
    setBpOtions = _useState46[1];
  var _useState47 = useState(null),
    _useState48 = _slicedToArray(_useState47, 2),
    createdBill = _useState48[0],
    setCreatedBill = _useState48[1];
  var _useState49 = useState([{
      value: 0,
      label: "Non defini"
    }]),
    _useState50 = _slicedToArray(_useState49, 2),
    prescribers = _useState50[0],
    setPrescribers = _useState50[1];
  var _useState51 = useState(false),
    _useState52 = _slicedToArray(_useState51, 2),
    dataChangedPr = _useState52[0],
    setDataChangedPr = _useState52[1];
  var _useState53 = useState(false),
    _useState54 = _slicedToArray(_useState53, 2),
    dataChangedBp = _useState54[0],
    setDataChangedBp = _useState54[1];
  var _useState55 = useState(false),
    _useState56 = _slicedToArray(_useState55, 2),
    showAddPrescriber = _useState56[0],
    setShowAddPrescriber = _useState56[1];
  var _useState57 = useState(false),
    _useState58 = _slicedToArray(_useState57, 2),
    showAddBusinessProvider = _useState58[0],
    setShowAddBusinessProvider = _useState58[1];
  var today = new Date();
  var date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
  var genderOptions = [{
    label: 'Homme',
    value: 'H'
  }, {
    label: 'Femme',
    value: 'F'
  }];
  var categoryOptions = [{
    label: 'Particulier',
    value: 0
  }, {
    label: 'Conventionné',
    value: 1
  }];
  var onCategorieChanged = function onCategorieChanged(e) {
    if (e == 1) {
      form.setFieldsValue({
        insurance_company_id: companyOptions
      });
      setCompanyDisabled(false);
      setInsDisabled(false);
      setUploadDisabled(false);
    } else {
      setCompanyDisabled(true);
      setInsDisabled(true);
      setUploadDisabled(true);
    }
  };
  var onDeptChanged = function onDeptChanged(e) {
    setServiceOptions([]);
    var optArray = e.toString().split(",");
    optArray.forEach(function (o) {
      var ar = serviceTree.filter(function (services) {
        return services.id == o;
      });
      if (ar.length > 0) {
        ar.forEach(function (d) {
          if (d.medical_items.length > 0) {
            d.medical_items.forEach(function (e) {
              setServiceOptions(function (prev) {
                return [].concat(_toConsumableArray(prev), [{
                  label: e.label,
                  value: e.id
                }]);
              });
            });
            form.setFieldsValue({
              service_id: serviceOptions
            });
            setServiceDisabled(false);
          }
        });
      }
    });
  };
  var onCompanyChanged = function onCompanyChanged(v) {
    setUserCompany(companies.filter(function (c) {
      return c.id == v;
    })[0]);
  };
  function printR() {
    var content = document.getElementById("prtdiv");
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  }
  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    }
  };
  var execOrder = function execOrder(formData) {
    setIsFormLoading(true);
    axios.post(Common.baseApiUrl + 'addcustomer/' + Common.currentUser.id.toString(), formData).then(function (response) {
      setIsFormLoading(false);
      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        setCreatedValues(response.data.customer);
        setCreatedBill(response.data.bill);
        form.resetFields();
        form.setFieldsValue({
          gender: 'F',
          category: 0,
          insnumber: null,
          business_provider_id: 0
        });
        handleUpdate();
        //printR();
        setShowReceipt(true);
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setIsFormLoading(false);
      setErrorMessage('Une erreur est survenue');
    });
  };
  var handlePdaChange = function handlePdaChange(checked) {
    setIsPdaActive(checked == true ? 1 : 0);
  };
  var onFinish = function onFinish(values) {
    setRdata([]);
    var formData = new FormData();
    formData.append('firstname', values.firstname);
    formData.append('lastname', values.lastname);
    formData.append('job', values.job);
    formData.append('birthdate', values.birthdate);
    formData.append('category', values.category);
    formData.append('mobile', values.mobile);
    formData.append('insnumber', values.insnumber);
    formData.append('prescriber_id', values.prescriber_id);
    formData.append('company_id', values.company_id);
    formData.append("address", values.address);
    formData.append('gender', values.gender);
    formData.append('department_id', values.department_id);
    formData.append('item_id', values.item_id);
    formData.append("user_id", Common.currentUser.id);
    formData.append("is_pda_active", isPdaActive);
    formData.append("discount", values.discount);
    formData.append("paid_amount", values.paid_amount);
    formData.append("business_provider_id", values.business_provider_id);
    var ta = 0;
    setDiscount(values.discount);
    values.item_id.toString().split(",").forEach(function (o) {
      serviceTree.forEach(function (d) {
        d.medical_items.forEach(function (e) {
          if (e.id == o) {
            //IF CASH PATIENT THE USE BASE PRICE
            if (values.category == 0) {
              ta += eval(e.base_price);
              setRdata(function (prev) {
                return [].concat(_toConsumableArray(prev), [e.label + " " + e.base_price.toLocaleString('fr') + " GNF"]);
              });
            } else {
              //HANDLING COMPANY PRICE CATEGORIES
              var comp = companies.filter(function (c) {
                return c.id == values.company_id;
              })[0];
              if (comp.company_id == null) {
                ta += eval(e.ent_price * (1 + comp.commercial_rate / 100));
                setRdata(function (prev) {
                  return [].concat(_toConsumableArray(prev), [e.label + "  " + (e.ent_price * (1 + comp.commercial_rate / 100)).toLocaleString('fr') + " GNF"]);
                });
              }
              if (comp.company_id != null && comp.company.type == 1) {
                ta += eval(e.ins_price * (1 + comp.company.commercial_rate / 100));
                setRdata(function (prev) {
                  return [].concat(_toConsumableArray(prev), [e.label + " " + (e.ins_price * (1 + comp.company.commercial_rate / 100)).toLocaleString('fr') + " GNF"]);
                });
              }
            }
          }
        });
      });
    });
    ta -= values.discount / 100 * ta;
    formData.append('amount', ta);
    if (values.category == 1) {
      if (companies.filter(function (c) {
        return c.id == values.company_id;
      }).length > 0) {
        var company_rate = companies.filter(function (c) {
          return c.id == values.company_id;
        })[0].rate;
        setCurrentCompany(companies.filter(function (c) {
          return c.id == values.company_id;
        })[0]);
        formData.append('company_part', ta * company_rate * 0.01);
        formData.append('patient_part', ta * (100 - company_rate) * 0.01);
        setReceipAmount(ta * (100 - company_rate) * 0.01);
      }
    } else {
      formData.append("patient_part", ta);
      formData.append("company_part", 0);
      setReceipAmount(ta);
    }
    setErrorMessage('');
    setSuccessMessage('');
    confirm({
      title: 'Confirmez-vous ?',
      icon: /*#__PURE__*/_jsx(ExclamationCircleFill, {}),
      content: /*#__PURE__*/_jsx(Receipt, {
        company: userCompany,
        discount: values.discount,
        is_pda_active: isPdaActive,
        options: values.item_id,
        serviceTree: serviceTree
      }),
      onOk: function onOk() {
        execOrder(formData);
      }
    });
  };
  useEffect(function () {
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 0,
        label: "0%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 1,
        label: "1%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 2,
        label: "2%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 3,
        label: "3%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 4,
        label: "4%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 5,
        label: "5%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 10,
        label: "10%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 15,
        label: "15%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 20,
        label: "20%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 25,
        label: "25%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 30,
        label: "30%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 35,
        label: "35%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 40,
        label: "40%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 45,
        label: "45%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 50,
        label: "50%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 55,
        label: "55%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 60,
        label: "60%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 65,
        label: "65%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 70,
        label: "70%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 75,
        label: "75%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 80,
        label: "80%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 85,
        label: "85%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 90,
        label: "90%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 95,
        label: "95%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 100,
        label: "100%"
      }]);
    });
    form.setFieldsValue({
      discount: 0
    });
    var cr = axios.get(Common.baseApiUrl + "getcompanylist");
    var st = axios.get(Common.baseApiUrl + "getservicetree");
    var bp = axios.get(Common.baseApiUrl + "getbusinessproviders/" + Common.currentUser.id);
    axios.all([cr, st, bp]).then(function (response) {
      var crResponse = response[0];
      var stResponse = response[1];
      var bpResponse = response[2];
      if (crResponse.data.status == 200) {
        setCompanies(crResponse.data.companyList);
        crResponse.data.companyList.forEach(function (c) {
          if (c.company_id == null) setCompanyOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: c.label,
              value: c.id
            }]);
          });else setCompanyOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: c.company == null ? "" : c.company.label + "-" + c.label,
              value: c.id
            }]);
          });
        });
        form.setFieldsValue({
          insurance_company_id: companyOptions
        });
      }
      if (stResponse.data.status == 200) {
        setServiceTree(stResponse.data.services);
        stResponse.data.services.forEach(function (d) {
          if (d.dcode != 'ADM' && d.dcode != "REC") setDeptOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: d.id,
              label: d.label
            }]);
          });
        });
        if (bpResponse.data.status == 200) {
          setBpOtions([{
            value: 0,
            label: "Direct"
          }]);
          bpResponse.data.providers.forEach(function (p) {
            setBpOtions(function (prev) {
              return [].concat(_toConsumableArray(prev), [{
                value: p.id,
                label: p.name + " (" + p.origin + ")"
              }]);
            });
          });
        }
        form.setFieldsValue({
          gender: 'F',
          category: 0,
          insnumber: null,
          business_provider_id: 0
        });
      }
    })["catch"](function (error) {});
  }, [dataChangedBp]);
  useEffect(function () {
    form.setFieldsValue({
      prescriber_id: 0,
      business_provider_id: 0,
      gender: 0
    });
    axios.get(Common.baseApiUrl + "getprescribers/" + Common.currentUser.id).then(function (response) {
      setPrescribers([{
        value: 0,
        label: "Non defini"
      }]);
      if (response.data.status == 200) {
        response.data.prescribers.forEach(function (p) {
          setPrescribers(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: p.id,
              label: p.name + "(" + p.mobile + ")"
            }]);
          });
        });
      }
    })["catch"](function (error) {})["finally"](function () {
      setDataChangedPr(false);
    });
  }, [dataChangedPr]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      message: errorMessage,
      type: "error",
      showIcon: true
    }), successMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      message: successMessage,
      type: "success",
      showIcon: true
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      onFinish: onFinish,
      form: form,
      size: "small",
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "business_provider_id",
            label: "Provenance",
            rules: [{
              required: true,
              message: 'Choisir la catégorie'
            }],
            children: /*#__PURE__*/_jsx(Select, {
              showSearch: true,
              defaultActiveFirstOption: true,
              optionLabelProp: "label",
              optionFilterProp: "label",
              filterOption: function filterOption(input, option) {
                return option.label.toLowerCase().includes(input.toLowerCase());
              },
              options: bpOptions,
              dropdownRender: function dropdownRender(menu) {
                return /*#__PURE__*/_jsxs(_Fragment, {
                  children: [menu, /*#__PURE__*/_jsx(Divider, {
                    style: {
                      margin: '8px 0'
                    }
                  }), /*#__PURE__*/_jsx(Space, {
                    style: {
                      padding: '0 8px 4px'
                    },
                    children: /*#__PURE__*/_jsx(Button, {
                      type: "text",
                      icon: /*#__PURE__*/_jsx(Plus, {
                        size: 22
                      }),
                      onClick: function onClick() {
                        setShowAddBusinessProvider(true);
                      },
                      children: "AJOUTER"
                    })
                  })]
                });
              }
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "prescriber_id",
            label: "Prescripteur",
            rules: [{
              required: true,
              message: 'Choisir la catégorie'
            }],
            children: /*#__PURE__*/_jsx(Select, {
              showSearch: true,
              defaultActiveFirstOption: true,
              optionLabelProp: "label",
              optionFilterProp: "label",
              filterOption: function filterOption(input, option) {
                return option.label.toLowerCase().includes(input.toLowerCase());
              },
              options: prescribers,
              dropdownRender: function dropdownRender(menu) {
                return /*#__PURE__*/_jsxs(_Fragment, {
                  children: [menu, /*#__PURE__*/_jsx(Divider, {
                    style: {
                      margin: '8px 0'
                    }
                  }), /*#__PURE__*/_jsx(Space, {
                    style: {
                      padding: '0 8px 4px'
                    },
                    children: /*#__PURE__*/_jsx(Button, {
                      type: "text",
                      icon: /*#__PURE__*/_jsx(Plus, {
                        size: 22
                      }),
                      onClick: function onClick() {
                        setShowAddPrescriber(true);
                      },
                      children: "AJOUTER"
                    })
                  })]
                });
              }
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "firstname",
            label: "Pr\xE9nom",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "lastname",
            label: "Nom",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "job",
            label: "Profession",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "mobile",
            label: "T\xE9l\xE9phone",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "birthdate",
            label: "Age",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "gender",
            label: "Genre",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Radio.Group, {
              options: genderOptions,
              optionType: "button",
              buttonStyle: "solid"
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 12,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "category",
            label: "Cat\xE9gorie",
            rules: [{
              required: true,
              message: 'Choisir la catégorie'
            }],
            children: /*#__PURE__*/_jsx(Select, {
              showSearch: true,
              defaultActiveFirstOption: true,
              onChange: onCategorieChanged,
              optionLabelProp: "label",
              optionFilterProp: "label",
              filterOption: function filterOption(input, option) {
                return option.label.toLowerCase().includes(input.toLowerCase());
              },
              options: categoryOptions
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 8,
          md: 12,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "company_id",
            label: "Prise en charge",
            children: /*#__PURE__*/_jsx(Select, {
              onChange: onCompanyChanged,
              disabled: companyDisabled,
              defaultActiveFirstOption: true,
              optionLabelProp: "label",
              optionFilterProp: "label",
              filterOption: function filterOption(input, option) {
                return option.label.toLowerCase().includes(input.toLowerCase());
              },
              showSearch: true,
              options: companyOptions
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "insnumber",
            label: "N\xBAprise en charge/ID assur\xE9",
            children: /*#__PURE__*/_jsx(Input, {
              disabled: insDisabled
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Adresse",
            name: "address",
            children: /*#__PURE__*/_jsx(Input, {})
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "department_id",
            label: "Motif",
            rules: [{
              required: true,
              message: 'Choisir le motif'
            }],
            children: /*#__PURE__*/_jsx(Select, {
              onChange: onDeptChanged,
              defaultActiveFirstOption: true,
              disabled: deptDisabled,
              showSearch: true,
              optionLabelProp: "label",
              optionFilterProp: "label",
              filterOption: function filterOption(input, option) {
                return option.label.toLowerCase().includes(input.toLowerCase());
              },
              options: deptOptions
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "item_id",
            label: "Actes / examens",
            rules: [{
              required: true,
              message: 'Choisir le motif'
            }],
            children: /*#__PURE__*/_jsx(Select, {
              mode: "multiple",
              defaultActiveFirstOption: true,
              disabled: serviceDisabled,
              showSearch: true,
              optionLabelProp: "label",
              optionFilterProp: "label",
              filterOption: function filterOption(input, option) {
                return option.label.toLowerCase().includes(input.toLowerCase());
              },
              options: serviceOptions
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 8,
          md: 7,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "discount",
            label: "Remise",
            rules: [{
              required: true,
              message: "Champ obligatoire"
            }],
            children: /*#__PURE__*/_jsx(Select, {
              options: discounts
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 5,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "PDA",
            children: /*#__PURE__*/_jsx(Switch, {
              onChange: handlePdaChange,
              size: "default",
              checked: isPdaActive == 1,
              checkedChildren: /*#__PURE__*/_jsx(CheckCircleFill, {}),
              unCheckedChildren: /*#__PURE__*/_jsx(XCircleFill, {})
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "paid_amount",
        children: /*#__PURE__*/_jsx(InputNumber, {
          placeholder: "Montant acompte",
          disabled: !isPdaActive,
          block: true
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "submit",
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormLoading,
          htmlType: "submit",
          type: "default",
          children: /*#__PURE__*/_jsx("b", {
            children: "ENREGISTRER"
          })
        })
      })]
    }), /*#__PURE__*/_jsx(Drawer, {
      open: showAddPrescriber,
      destroyOnClose: true,
      title: /*#__PURE__*/_jsx("b", {
        children: "AJOUTER UN PRESCRIPTEUR"
      }),
      onClose: function onClose() {
        setShowAddPrescriber(false);
      },
      width: "290px",
      children: /*#__PURE__*/_jsx(AddPrescriber, {
        handler: function handler() {
          setDataChangedPr(true);
          setShowAddPrescriber(false);
        }
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      open: showAddBusinessProvider,
      destroyOnClose: true,
      title: /*#__PURE__*/_jsx("b", {
        children: "AJOUTER UN AMBULANCIER"
      }),
      onClose: function onClose() {
        setShowAddBusinessProvider(false);
      },
      width: "290px",
      children: /*#__PURE__*/_jsx(AddBusinessProvider, {
        handler: function handler() {
          setDataChangedBp(true);
          setShowAddBusinessProvider(false);
        }
      })
    }), createdValues && /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsxs("b", {
        children: [/*#__PURE__*/_jsx(CheckCircleFill, {
          size: 30
        }), " RECU"]
      }),
      width: "280px",
      open: showReceipt,
      onClose: function onClose() {
        setShowReceipt(false);
      },
      destroyOnClose: true,
      extra: [/*#__PURE__*/_jsx(ReactToPrint, {
        content: function content() {
          return ref.current;
        },
        children: /*#__PURE__*/_jsx(PrintContextConsumer, {
          children: function children(_ref2) {
            var handlePrint = _ref2.handlePrint;
            return /*#__PURE__*/_jsx(Button, {
              type: "primary",
              onClick: handlePrint,
              children: /*#__PURE__*/_jsx("b", {
                children: "IMPRIMER"
              })
            });
          }
        })
      })],
      children: /*#__PURE__*/_jsxs("div", {
        ref: ref,
        style: {
          textAlign: 'center'
        },
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            width: '130px',
            textAlign: 'center !important'
          },
          children: /*#__PURE__*/_jsx("img", {
            src: "drawables/emgl.png",
            style: {
              width: '100%'
            }
          })
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx("b", {
            children: "Date:"
          }), " ", /*#__PURE__*/_jsx(Moment, {
            format: "DD/MM/YYYY H:m"
          })]
        }), /*#__PURE__*/_jsxs("h2", {
          children: ["ID PATIENT : ", createdValues.idnumber]
        }), /*#__PURE__*/_jsxs("h5", {
          children: ["Nom : ", createdValues.firstname + " " + createdValues.lastname]
        }), /*#__PURE__*/_jsx(List, {
          header: /*#__PURE__*/_jsx("div", {
            children: "Actes / Produit(s)"
          }),
          footer: /*#__PURE__*/_jsx("b", {
            children: "TOTAL (GNF) " + receipAmount.toLocaleString('Fr')
          }),
          bordered: true,
          dataSource: rdata,
          renderItem: function renderItem(item) {
            return /*#__PURE__*/_jsx(List.Item, {
              children: /*#__PURE__*/_jsx(Typography.Text, {
                mark: true,
                children: item
              })
            });
          }
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
          children: ["REMISE ", discount, "% ", isPdaActive == 1 && /*#__PURE__*/_jsx("span", {
            style: {
              color: "#8F4F31"
            },
            children: "(*Paiement diff\xE9r\xE9 autoris\xE9)"
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
          style: {
            textAlign: "center"
          },
          children: createdBill && /*#__PURE__*/_jsx(QRCode, {
            type: "svg",
            value: "https://cik.cliniqueadmin.com/#/checkreceipt/" + createdBill.id.toString(),
            size: 65
          })
        }), /*#__PURE__*/_jsx("br", {}), currentCompany != null && /*#__PURE__*/_jsx(Alert, {
          type: "warning",
          banner: true,
          message: "Prise en charge de " + currentCompany.rate.toString() + "% par " + currentCompany.label
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx("b", {
            children: "Adresse: Kissidougou, Korodou, Secteur II - Route Nationale N\xB01 - Tel: 622342787/621128638"
          })
        })]
      })
    })]
  });
};
export default NewCustomer;